// removed by extract-text-webpack-plugin
module.exports = {"paragraph":"dh-trygdis-kvinnefengsel-paragraph"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/@nrk/dh-feature-components/Paragraph/index.css
// module id = 189
// module chunks = 0